export default __webpack_public_path__ + "static/media/spooky_hill_s2.079f9f6c.png";